import { AsyncPipe, ViewportScroller } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  BackNavigable,
  BackNavigationService,
  showRequestErrors,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { Store } from '@softline/core';
import { LoadingSkeletonComponent, TranslatePipe } from '@softline/ui-core';
import { AuftragStore } from '../../store';
import { SOFTLINE_FEATURE_TRANSPORTAUFTRAG } from '../../transport.shared';
import { CardComponent } from './card/card.component';
import { PageComponent } from "@softapps/core/pages";

@Component({
  selector: 'soft-transport-overview',
  imports: [AsyncPipe, CardComponent, LoadingSkeletonComponent, TranslatePipe, PageComponent],
  templateUrl: './transport-list.component.html',
  styleUrls: ['./transport-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportListComponent implements OnInit, OnDestroy, BackNavigable {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly viewportScroller = inject(ViewportScroller);
  private readonly backNavigationService = inject(BackNavigationService);

  readonly auftraege$ = this.store.observe(
    SOFTLINE_FEATURE_TRANSPORTAUFTRAG,
    AuftragStore.getters.all
  );

  readonly loading$ = this.store.observe(
    SOFTLINE_FEATURE_TRANSPORTAUFTRAG,
    AuftragStore.getters.loading
  );

  async ngOnInit(): Promise<void> {
    this.viewportScroller.scrollToPosition([0, 0]);
    const content = document?.getElementsByTagName('soft-pull-to-refresh-container');
    content[0].scrollTop = 0;

    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      'Energietransport'
    );
    this.backNavigationService.set(this);

    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_TRANSPORTAUFTRAG,
        AuftragStore.actions.loadMany,
        { clear: true }
      );
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }
}
